// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__bZul_","col":"styles_col__2LCjc"};